/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = `mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
    owner
    email
    phone
    first_name
    last_name
    photo_url
    cover_url
    notes
    active
    createdAt
    watchlist {
      watchlistVideoId
      createdAt
    }
    currentVideo {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    history {
      historyVideoId
      createdAt
    }
    favorites {
      favoriteVideoId
      createdAt
    }
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    userDesignerId
    subs {
      items {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        subDesignerId
        stripeId
        stripeSubId
        createdAt
        owner
      }
      nextToken
    }
    orders {
      items {
        id
        owner
        customer {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        orderCustomerId
        total
        order
        createdAt
      }
      nextToken
    }
    cart {
      id
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      owner
      items
    }
  }
}
`;
export const updateUser = `mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    owner
    email
    phone
    first_name
    last_name
    photo_url
    cover_url
    notes
    active
    createdAt
    watchlist {
      watchlistVideoId
      createdAt
    }
    currentVideo {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    history {
      historyVideoId
      createdAt
    }
    favorites {
      favoriteVideoId
      createdAt
    }
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    userDesignerId
    subs {
      items {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        subDesignerId
        stripeId
        stripeSubId
        createdAt
        owner
      }
      nextToken
    }
    orders {
      items {
        id
        owner
        customer {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        orderCustomerId
        total
        order
        createdAt
      }
      nextToken
    }
    cart {
      id
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      owner
      items
    }
  }
}
`;
export const deleteUser = `mutation DeleteUser($input: DeleteUserInput!) {
  deleteUser(input: $input) {
    id
    owner
    email
    phone
    first_name
    last_name
    photo_url
    cover_url
    notes
    active
    createdAt
    watchlist {
      watchlistVideoId
      createdAt
    }
    currentVideo {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    history {
      historyVideoId
      createdAt
    }
    favorites {
      favoriteVideoId
      createdAt
    }
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    userDesignerId
    subs {
      items {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        subDesignerId
        stripeId
        stripeSubId
        createdAt
        owner
      }
      nextToken
    }
    orders {
      items {
        id
        owner
        customer {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        orderCustomerId
        total
        order
        createdAt
      }
      nextToken
    }
    cart {
      id
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      owner
      items
    }
  }
}
`;
export const createCart = `mutation CreateCart($input: CreateCartInput!) {
  createCart(input: $input) {
    id
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    owner
    items
  }
}
`;
export const updateCart = `mutation UpdateCart($input: UpdateCartInput!) {
  updateCart(input: $input) {
    id
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    owner
    items
  }
}
`;
export const deleteCart = `mutation DeleteCart($input: DeleteCartInput!) {
  deleteCart(input: $input) {
    id
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    owner
    items
  }
}
`;
export const createSub = `mutation CreateSub($input: CreateSubInput!) {
  createSub(input: $input) {
    id
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    subDesignerId
    stripeId
    stripeSubId
    createdAt
    owner
  }
}
`;
export const updateSub = `mutation UpdateSub($input: UpdateSubInput!) {
  updateSub(input: $input) {
    id
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    subDesignerId
    stripeId
    stripeSubId
    createdAt
    owner
  }
}
`;
export const deleteSub = `mutation DeleteSub($input: DeleteSubInput!) {
  deleteSub(input: $input) {
    id
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    subDesignerId
    stripeId
    stripeSubId
    createdAt
    owner
  }
}
`;
export const createCategory = `mutation CreateCategory($input: CreateCategoryInput!) {
  createCategory(input: $input) {
    id
    owner
    name
    description
    createdAt
    videos {
      items {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
  }
}
`;
export const updateCategory = `mutation UpdateCategory($input: UpdateCategoryInput!) {
  updateCategory(input: $input) {
    id
    owner
    name
    description
    createdAt
    videos {
      items {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
  }
}
`;
export const deleteCategory = `mutation DeleteCategory($input: DeleteCategoryInput!) {
  deleteCategory(input: $input) {
    id
    owner
    name
    description
    createdAt
    videos {
      items {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
  }
}
`;
export const createShow = `mutation CreateShow($input: CreateShowInput!) {
  createShow(input: $input) {
    id
    owner
    title
    description
    release_date
    videos {
      items {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
  }
}
`;
export const updateShow = `mutation UpdateShow($input: UpdateShowInput!) {
  updateShow(input: $input) {
    id
    owner
    title
    description
    release_date
    videos {
      items {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
  }
}
`;
export const deleteShow = `mutation DeleteShow($input: DeleteShowInput!) {
  deleteShow(input: $input) {
    id
    owner
    title
    description
    release_date
    videos {
      items {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
  }
}
`;
export const createVideo = `mutation CreateVideo($input: CreateVideoInput!) {
  createVideo(input: $input) {
    id
    owner
    title
    description
    status
    url
    thumbnail
    createdAt
    views {
      user
      video
      createdAt
    }
    comments {
      items {
        id
        owner
        content
        avatar
        name
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        commentPostId
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        commentVideoId
        createdAt
        likes
        subs
      }
      nextToken
    }
    products {
      items {
        id
        owner
        product {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        timestamp
      }
      nextToken
    }
    category {
      id
      owner
      name
      description
      createdAt
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    designers {
      items {
        id
        owner
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    show {
      id
      owner
      title
      description
      release_date
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    season
    episode
    release_date
    duration
    likes
    src_video
    tags {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
  }
}
`;
export const updateVideo = `mutation UpdateVideo($input: UpdateVideoInput!) {
  updateVideo(input: $input) {
    id
    owner
    title
    description
    status
    url
    thumbnail
    createdAt
    views {
      user
      video
      createdAt
    }
    comments {
      items {
        id
        owner
        content
        avatar
        name
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        commentPostId
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        commentVideoId
        createdAt
        likes
        subs
      }
      nextToken
    }
    products {
      items {
        id
        owner
        product {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        timestamp
      }
      nextToken
    }
    category {
      id
      owner
      name
      description
      createdAt
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    designers {
      items {
        id
        owner
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    show {
      id
      owner
      title
      description
      release_date
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    season
    episode
    release_date
    duration
    likes
    src_video
    tags {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
  }
}
`;
export const deleteVideo = `mutation DeleteVideo($input: DeleteVideoInput!) {
  deleteVideo(input: $input) {
    id
    owner
    title
    description
    status
    url
    thumbnail
    createdAt
    views {
      user
      video
      createdAt
    }
    comments {
      items {
        id
        owner
        content
        avatar
        name
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        commentPostId
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        commentVideoId
        createdAt
        likes
        subs
      }
      nextToken
    }
    products {
      items {
        id
        owner
        product {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        timestamp
      }
      nextToken
    }
    category {
      id
      owner
      name
      description
      createdAt
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    designers {
      items {
        id
        owner
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    show {
      id
      owner
      title
      description
      release_date
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    season
    episode
    release_date
    duration
    likes
    src_video
    tags {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
  }
}
`;
export const createTagsDesigners = `mutation CreateTagsDesigners($input: CreateTagsDesignersInput!) {
  createTagsDesigners(input: $input) {
    id
    tag {
      id
      tag
      type
      videos {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      designers {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      owner
    }
    tagsDesignersTagId
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    tagsDesignersDesignerId
  }
}
`;
export const updateTagsDesigners = `mutation UpdateTagsDesigners($input: UpdateTagsDesignersInput!) {
  updateTagsDesigners(input: $input) {
    id
    tag {
      id
      tag
      type
      videos {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      designers {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      owner
    }
    tagsDesignersTagId
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    tagsDesignersDesignerId
  }
}
`;
export const deleteTagsDesigners = `mutation DeleteTagsDesigners($input: DeleteTagsDesignersInput!) {
  deleteTagsDesigners(input: $input) {
    id
    tag {
      id
      tag
      type
      videos {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      designers {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      owner
    }
    tagsDesignersTagId
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    tagsDesignersDesignerId
  }
}
`;
export const createTagsVideos = `mutation CreateTagsVideos($input: CreateTagsVideosInput!) {
  createTagsVideos(input: $input) {
    id
    tag {
      id
      tag
      type
      videos {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      designers {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      owner
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
  }
}
`;
export const updateTagsVideos = `mutation UpdateTagsVideos($input: UpdateTagsVideosInput!) {
  updateTagsVideos(input: $input) {
    id
    tag {
      id
      tag
      type
      videos {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      designers {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      owner
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
  }
}
`;
export const deleteTagsVideos = `mutation DeleteTagsVideos($input: DeleteTagsVideosInput!) {
  deleteTagsVideos(input: $input) {
    id
    tag {
      id
      tag
      type
      videos {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      designers {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      owner
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
  }
}
`;
export const createTag = `mutation CreateTag($input: CreateTagInput!) {
  createTag(input: $input) {
    id
    tag
    type
    videos {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    designers {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        tagsDesignersTagId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        tagsDesignersDesignerId
      }
      nextToken
    }
    owner
  }
}
`;
export const updateTag = `mutation UpdateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    id
    tag
    type
    videos {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    designers {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        tagsDesignersTagId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        tagsDesignersDesignerId
      }
      nextToken
    }
    owner
  }
}
`;
export const deleteTag = `mutation DeleteTag($input: DeleteTagInput!) {
  deleteTag(input: $input) {
    id
    tag
    type
    videos {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    designers {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        tagsDesignersTagId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        tagsDesignersDesignerId
      }
      nextToken
    }
    owner
  }
}
`;
export const createPendingVideo = `mutation CreatePendingVideo($input: CreatePendingVideoInput!) {
  createPendingVideo(input: $input) {
    id
    owner
    title
    description
    status
    createdAt
    src_video
    category {
      id
      owner
      name
      description
      createdAt
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    pendingVideoCategoryId
    show {
      id
      owner
      title
      description
      release_date
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    pendingVideoShowId
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    pendingVideoDesignerId
    season
    episode
    duration
  }
}
`;
export const updatePendingVideo = `mutation UpdatePendingVideo($input: UpdatePendingVideoInput!) {
  updatePendingVideo(input: $input) {
    id
    owner
    title
    description
    status
    createdAt
    src_video
    category {
      id
      owner
      name
      description
      createdAt
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    pendingVideoCategoryId
    show {
      id
      owner
      title
      description
      release_date
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    pendingVideoShowId
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    pendingVideoDesignerId
    season
    episode
    duration
  }
}
`;
export const deletePendingVideo = `mutation DeletePendingVideo($input: DeletePendingVideoInput!) {
  deletePendingVideo(input: $input) {
    id
    owner
    title
    description
    status
    createdAt
    src_video
    category {
      id
      owner
      name
      description
      createdAt
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    pendingVideoCategoryId
    show {
      id
      owner
      title
      description
      release_date
      videos {
        items {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
    }
    pendingVideoShowId
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    pendingVideoDesignerId
    season
    episode
    duration
  }
}
`;
export const createProductVideo = `mutation CreateProductVideo($input: CreateProductVideoInput!) {
  createProductVideo(input: $input) {
    id
    owner
    product {
      id
      upc
      owner
      name
      description
      caption
      collection
      attributes
      price
      image
      supplier {
        id
        name
        description
        address
        phone
        contact
        url
        api
        schema
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        owner
      }
      product_id
      meta
      active
      createdAt
      box_size
      designer
      videos {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      relatedItems {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      relatedTo {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      productCategoryId
      mainProductCategoryId
      category {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    timestamp
  }
}
`;
export const updateProductVideo = `mutation UpdateProductVideo($input: UpdateProductVideoInput!) {
  updateProductVideo(input: $input) {
    id
    owner
    product {
      id
      upc
      owner
      name
      description
      caption
      collection
      attributes
      price
      image
      supplier {
        id
        name
        description
        address
        phone
        contact
        url
        api
        schema
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        owner
      }
      product_id
      meta
      active
      createdAt
      box_size
      designer
      videos {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      relatedItems {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      relatedTo {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      productCategoryId
      mainProductCategoryId
      category {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    timestamp
  }
}
`;
export const deleteProductVideo = `mutation DeleteProductVideo($input: DeleteProductVideoInput!) {
  deleteProductVideo(input: $input) {
    id
    owner
    product {
      id
      upc
      owner
      name
      description
      caption
      collection
      attributes
      price
      image
      supplier {
        id
        name
        description
        address
        phone
        contact
        url
        api
        schema
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        owner
      }
      product_id
      meta
      active
      createdAt
      box_size
      designer
      videos {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      relatedItems {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      relatedTo {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      productCategoryId
      mainProductCategoryId
      category {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    timestamp
  }
}
`;
export const createProduct = `mutation CreateProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    id
    upc
    owner
    name
    description
    caption
    collection
    attributes
    price
    image
    supplier {
      id
      name
      description
      address
      phone
      contact
      url
      api
      schema
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      owner
    }
    product_id
    meta
    active
    createdAt
    box_size
    designer
    videos {
      items {
        id
        owner
        product {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        timestamp
      }
      nextToken
    }
    relatedItems {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
    relatedTo {
      id
      upc
      owner
      name
      description
      caption
      collection
      attributes
      price
      image
      supplier {
        id
        name
        description
        address
        phone
        contact
        url
        api
        schema
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        owner
      }
      product_id
      meta
      active
      createdAt
      box_size
      designer
      videos {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      relatedItems {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      relatedTo {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      productCategoryId
      mainProductCategoryId
      category {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
    }
    productCategoryId
    mainProductCategoryId
    category {
      id
      owner
      name
      slug
      image
      createdAt
      isMainCategory
      subCategories {
        items {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        nextToken
      }
      mainCategory {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      productCategoryMainCategoryId
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
    }
  }
}
`;
export const updateProduct = `mutation UpdateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    id
    upc
    owner
    name
    description
    caption
    collection
    attributes
    price
    image
    supplier {
      id
      name
      description
      address
      phone
      contact
      url
      api
      schema
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      owner
    }
    product_id
    meta
    active
    createdAt
    box_size
    designer
    videos {
      items {
        id
        owner
        product {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        timestamp
      }
      nextToken
    }
    relatedItems {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
    relatedTo {
      id
      upc
      owner
      name
      description
      caption
      collection
      attributes
      price
      image
      supplier {
        id
        name
        description
        address
        phone
        contact
        url
        api
        schema
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        owner
      }
      product_id
      meta
      active
      createdAt
      box_size
      designer
      videos {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      relatedItems {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      relatedTo {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      productCategoryId
      mainProductCategoryId
      category {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
    }
    productCategoryId
    mainProductCategoryId
    category {
      id
      owner
      name
      slug
      image
      createdAt
      isMainCategory
      subCategories {
        items {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        nextToken
      }
      mainCategory {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      productCategoryMainCategoryId
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
    }
  }
}
`;
export const deleteProduct = `mutation DeleteProduct($input: DeleteProductInput!) {
  deleteProduct(input: $input) {
    id
    upc
    owner
    name
    description
    caption
    collection
    attributes
    price
    image
    supplier {
      id
      name
      description
      address
      phone
      contact
      url
      api
      schema
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      owner
    }
    product_id
    meta
    active
    createdAt
    box_size
    designer
    videos {
      items {
        id
        owner
        product {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        timestamp
      }
      nextToken
    }
    relatedItems {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
    relatedTo {
      id
      upc
      owner
      name
      description
      caption
      collection
      attributes
      price
      image
      supplier {
        id
        name
        description
        address
        phone
        contact
        url
        api
        schema
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        owner
      }
      product_id
      meta
      active
      createdAt
      box_size
      designer
      videos {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      relatedItems {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
      relatedTo {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      productCategoryId
      mainProductCategoryId
      category {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
    }
    productCategoryId
    mainProductCategoryId
    category {
      id
      owner
      name
      slug
      image
      createdAt
      isMainCategory
      subCategories {
        items {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        nextToken
      }
      mainCategory {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      productCategoryMainCategoryId
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
    }
  }
}
`;
export const createProductCategory = `mutation CreateProductCategory($input: CreateProductCategoryInput!) {
  createProductCategory(input: $input) {
    id
    owner
    name
    slug
    image
    createdAt
    isMainCategory
    subCategories {
      items {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      nextToken
    }
    mainCategory {
      id
      owner
      name
      slug
      image
      createdAt
      isMainCategory
      subCategories {
        items {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        nextToken
      }
      mainCategory {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      productCategoryMainCategoryId
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
    }
    productCategoryMainCategoryId
    products {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
  }
}
`;
export const updateProductCategory = `mutation UpdateProductCategory($input: UpdateProductCategoryInput!) {
  updateProductCategory(input: $input) {
    id
    owner
    name
    slug
    image
    createdAt
    isMainCategory
    subCategories {
      items {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      nextToken
    }
    mainCategory {
      id
      owner
      name
      slug
      image
      createdAt
      isMainCategory
      subCategories {
        items {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        nextToken
      }
      mainCategory {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      productCategoryMainCategoryId
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
    }
    productCategoryMainCategoryId
    products {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
  }
}
`;
export const deleteProductCategory = `mutation DeleteProductCategory($input: DeleteProductCategoryInput!) {
  deleteProductCategory(input: $input) {
    id
    owner
    name
    slug
    image
    createdAt
    isMainCategory
    subCategories {
      items {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      nextToken
    }
    mainCategory {
      id
      owner
      name
      slug
      image
      createdAt
      isMainCategory
      subCategories {
        items {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        nextToken
      }
      mainCategory {
        id
        owner
        name
        slug
        image
        createdAt
        isMainCategory
        subCategories {
          items {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          nextToken
        }
        mainCategory {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
        productCategoryMainCategoryId
        products {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
      }
      productCategoryMainCategoryId
      products {
        items {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        nextToken
      }
    }
    productCategoryMainCategoryId
    products {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
  }
}
`;
export const createSupplier = `mutation CreateSupplier($input: CreateSupplierInput!) {
  createSupplier(input: $input) {
    id
    name
    description
    address
    phone
    contact
    url
    api
    schema
    products {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
    owner
  }
}
`;
export const updateSupplier = `mutation UpdateSupplier($input: UpdateSupplierInput!) {
  updateSupplier(input: $input) {
    id
    name
    description
    address
    phone
    contact
    url
    api
    schema
    products {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
    owner
  }
}
`;
export const deleteSupplier = `mutation DeleteSupplier($input: DeleteSupplierInput!) {
  deleteSupplier(input: $input) {
    id
    name
    description
    address
    phone
    contact
    url
    api
    schema
    products {
      items {
        id
        upc
        owner
        name
        description
        caption
        collection
        attributes
        price
        image
        supplier {
          id
          name
          description
          address
          phone
          contact
          url
          api
          schema
          products {
            nextToken
          }
          owner
        }
        product_id
        meta
        active
        createdAt
        box_size
        designer
        videos {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        relatedItems {
          items {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          nextToken
        }
        relatedTo {
          id
          upc
          owner
          name
          description
          caption
          collection
          attributes
          price
          image
          supplier {
            id
            name
            description
            address
            phone
            contact
            url
            api
            schema
            owner
          }
          product_id
          meta
          active
          createdAt
          box_size
          designer
          videos {
            nextToken
          }
          relatedItems {
            nextToken
          }
          relatedTo {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          productCategoryId
          mainProductCategoryId
          category {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
        }
        productCategoryId
        mainProductCategoryId
        category {
          id
          owner
          name
          slug
          image
          createdAt
          isMainCategory
          subCategories {
            nextToken
          }
          mainCategory {
            id
            owner
            name
            slug
            image
            createdAt
            isMainCategory
            productCategoryMainCategoryId
          }
          productCategoryMainCategoryId
          products {
            nextToken
          }
        }
      }
      nextToken
    }
    owner
  }
}
`;
export const createOrder = `mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    id
    owner
    customer {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    orderCustomerId
    total
    order
    createdAt
  }
}
`;
export const updateOrder = `mutation UpdateOrder($input: UpdateOrderInput!) {
  updateOrder(input: $input) {
    id
    owner
    customer {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    orderCustomerId
    total
    order
    createdAt
  }
}
`;
export const deleteOrder = `mutation DeleteOrder($input: DeleteOrderInput!) {
  deleteOrder(input: $input) {
    id
    owner
    customer {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    orderCustomerId
    total
    order
    createdAt
  }
}
`;
export const createVideoCast = `mutation CreateVideoCast($input: CreateVideoCastInput!) {
  createVideoCast(input: $input) {
    id
    owner
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
  }
}
`;
export const updateVideoCast = `mutation UpdateVideoCast($input: UpdateVideoCastInput!) {
  updateVideoCast(input: $input) {
    id
    owner
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
  }
}
`;
export const deleteVideoCast = `mutation DeleteVideoCast($input: DeleteVideoCastInput!) {
  deleteVideoCast(input: $input) {
    id
    owner
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
  }
}
`;
export const createDesigner = `mutation CreateDesigner($input: CreateDesignerInput!) {
  createDesigner(input: $input) {
    id
    owner
    email
    phone
    name
    photo_url
    bio
    location
    active
    createdAt
    posts {
      items {
        id
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        editor {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
      }
      nextToken
    }
    videos {
      items {
        id
        owner
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    tags {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        tagsDesignersTagId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        tagsDesignersDesignerId
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
    pro
    subs {
      items {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        subDesignerId
        stripeId
        stripeSubId
        createdAt
        owner
      }
      nextToken
    }
    profile {
      first_name
      last_name
      name
      bio
      company_name
      title
      address_line1
      address_line2
      city
      state
      zip_code
      country
      website_url
      allow_contact_email
      facebook_handle
      twitter_handle
      youtube_handle
      pinterest_handle
      instagram_handle
      linkedin_url
      blog_url
      google_plus_url
      houzz_url
      feature_video
      availables
      certifications
      photo_url
      cover_url
      status
    }
    draft_profile {
      first_name
      last_name
      name
      bio
      company_name
      title
      address_line1
      address_line2
      city
      state
      zip_code
      country
      website_url
      allow_contact_email
      facebook_handle
      twitter_handle
      youtube_handle
      pinterest_handle
      instagram_handle
      linkedin_url
      blog_url
      google_plus_url
      houzz_url
      feature_video
      availables
      certifications
      photo_url
      cover_url
      status
    }
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    projects {
      items {
        id
        title
        description
        images
        videos
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        projectDesignerId
        owner
      }
      nextToken
    }
  }
}
`;
export const updateDesigner = `mutation UpdateDesigner($input: UpdateDesignerInput!) {
  updateDesigner(input: $input) {
    id
    owner
    email
    phone
    name
    photo_url
    bio
    location
    active
    createdAt
    posts {
      items {
        id
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        editor {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
      }
      nextToken
    }
    videos {
      items {
        id
        owner
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    tags {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        tagsDesignersTagId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        tagsDesignersDesignerId
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
    pro
    subs {
      items {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        subDesignerId
        stripeId
        stripeSubId
        createdAt
        owner
      }
      nextToken
    }
    profile {
      first_name
      last_name
      name
      bio
      company_name
      title
      address_line1
      address_line2
      city
      state
      zip_code
      country
      website_url
      allow_contact_email
      facebook_handle
      twitter_handle
      youtube_handle
      pinterest_handle
      instagram_handle
      linkedin_url
      blog_url
      google_plus_url
      houzz_url
      feature_video
      availables
      certifications
      photo_url
      cover_url
      status
    }
    draft_profile {
      first_name
      last_name
      name
      bio
      company_name
      title
      address_line1
      address_line2
      city
      state
      zip_code
      country
      website_url
      allow_contact_email
      facebook_handle
      twitter_handle
      youtube_handle
      pinterest_handle
      instagram_handle
      linkedin_url
      blog_url
      google_plus_url
      houzz_url
      feature_video
      availables
      certifications
      photo_url
      cover_url
      status
    }
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    projects {
      items {
        id
        title
        description
        images
        videos
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        projectDesignerId
        owner
      }
      nextToken
    }
  }
}
`;
export const deleteDesigner = `mutation DeleteDesigner($input: DeleteDesignerInput!) {
  deleteDesigner(input: $input) {
    id
    owner
    email
    phone
    name
    photo_url
    bio
    location
    active
    createdAt
    posts {
      items {
        id
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        editor {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
      }
      nextToken
    }
    videos {
      items {
        id
        owner
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
      }
      nextToken
    }
    tags {
      items {
        id
        tag {
          id
          tag
          type
          videos {
            nextToken
          }
          designers {
            nextToken
          }
          owner
        }
        tagsDesignersTagId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        tagsDesignersDesignerId
      }
      nextToken
    }
    pendingVideos {
      items {
        id
        owner
        title
        description
        status
        createdAt
        src_video
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoCategoryId
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        pendingVideoShowId
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        pendingVideoDesignerId
        season
        episode
        duration
      }
      nextToken
    }
    pro
    subs {
      items {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        subDesignerId
        stripeId
        stripeSubId
        createdAt
        owner
      }
      nextToken
    }
    profile {
      first_name
      last_name
      name
      bio
      company_name
      title
      address_line1
      address_line2
      city
      state
      zip_code
      country
      website_url
      allow_contact_email
      facebook_handle
      twitter_handle
      youtube_handle
      pinterest_handle
      instagram_handle
      linkedin_url
      blog_url
      google_plus_url
      houzz_url
      feature_video
      availables
      certifications
      photo_url
      cover_url
      status
    }
    draft_profile {
      first_name
      last_name
      name
      bio
      company_name
      title
      address_line1
      address_line2
      city
      state
      zip_code
      country
      website_url
      allow_contact_email
      facebook_handle
      twitter_handle
      youtube_handle
      pinterest_handle
      instagram_handle
      linkedin_url
      blog_url
      google_plus_url
      houzz_url
      feature_video
      availables
      certifications
      photo_url
      cover_url
      status
    }
    user {
      id
      owner
      email
      phone
      first_name
      last_name
      photo_url
      cover_url
      notes
      active
      createdAt
      watchlist {
        watchlistVideoId
        createdAt
      }
      currentVideo {
        id
        owner
        title
        description
        status
        url
        thumbnail
        createdAt
        views {
          user
          video
          createdAt
        }
        comments {
          items {
            id
            owner
            content
            avatar
            name
            commentPostId
            commentVideoId
            createdAt
            likes
            subs
          }
          nextToken
        }
        products {
          items {
            id
            owner
            timestamp
          }
          nextToken
        }
        category {
          id
          owner
          name
          description
          createdAt
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        designers {
          items {
            id
            owner
          }
          nextToken
        }
        show {
          id
          owner
          title
          description
          release_date
          videos {
            nextToken
          }
          pendingVideos {
            nextToken
          }
        }
        season
        episode
        release_date
        duration
        likes
        src_video
        tags {
          items {
            id
          }
          nextToken
        }
      }
      history {
        historyVideoId
        createdAt
      }
      favorites {
        favoriteVideoId
        createdAt
      }
      designer {
        id
        owner
        email
        phone
        name
        photo_url
        bio
        location
        active
        createdAt
        posts {
          items {
            id
          }
          nextToken
        }
        videos {
          items {
            id
            owner
          }
          nextToken
        }
        tags {
          items {
            id
            tagsDesignersTagId
            tagsDesignersDesignerId
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
        pro
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        draft_profile {
          first_name
          last_name
          name
          bio
          company_name
          title
          address_line1
          address_line2
          city
          state
          zip_code
          country
          website_url
          allow_contact_email
          facebook_handle
          twitter_handle
          youtube_handle
          pinterest_handle
          instagram_handle
          linkedin_url
          blog_url
          google_plus_url
          houzz_url
          feature_video
          availables
          certifications
          photo_url
          cover_url
          status
        }
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        projects {
          items {
            id
            title
            description
            images
            videos
            projectDesignerId
            owner
          }
          nextToken
        }
      }
      userDesignerId
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      orders {
        items {
          id
          owner
          customer {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          orderCustomerId
          total
          order
          createdAt
        }
        nextToken
      }
      cart {
        id
        user {
          id
          owner
          email
          phone
          first_name
          last_name
          photo_url
          cover_url
          notes
          active
          createdAt
          watchlist {
            watchlistVideoId
            createdAt
          }
          currentVideo {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          history {
            historyVideoId
            createdAt
          }
          favorites {
            favoriteVideoId
            createdAt
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          userDesignerId
          subs {
            nextToken
          }
          orders {
            nextToken
          }
          cart {
            id
            owner
            items
          }
        }
        owner
        items
      }
    }
    projects {
      items {
        id
        title
        description
        images
        videos
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        projectDesignerId
        owner
      }
      nextToken
    }
  }
}
`;
export const createProject = `mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
    title
    description
    images
    videos
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    projectDesignerId
    owner
  }
}
`;
export const updateProject = `mutation UpdateProject($input: UpdateProjectInput!) {
  updateProject(input: $input) {
    id
    title
    description
    images
    videos
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    projectDesignerId
    owner
  }
}
`;
export const deleteProject = `mutation DeleteProject($input: DeleteProjectInput!) {
  deleteProject(input: $input) {
    id
    title
    description
    images
    videos
    designer {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
    projectDesignerId
    owner
  }
}
`;
export const createPostEditor = `mutation CreatePostEditor($input: CreatePostEditorInput!) {
  createPostEditor(input: $input) {
    id
    post {
      id
      owner
      title
      description
      content
      status
      thumbnail
      editors {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      createdAt
      likes
      liked
    }
    editor {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
  }
}
`;
export const updatePostEditor = `mutation UpdatePostEditor($input: UpdatePostEditorInput!) {
  updatePostEditor(input: $input) {
    id
    post {
      id
      owner
      title
      description
      content
      status
      thumbnail
      editors {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      createdAt
      likes
      liked
    }
    editor {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
  }
}
`;
export const deletePostEditor = `mutation DeletePostEditor($input: DeletePostEditorInput!) {
  deletePostEditor(input: $input) {
    id
    post {
      id
      owner
      title
      description
      content
      status
      thumbnail
      editors {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      createdAt
      likes
      liked
    }
    editor {
      id
      owner
      email
      phone
      name
      photo_url
      bio
      location
      active
      createdAt
      posts {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      videos {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          tagsDesignersTagId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          tagsDesignersDesignerId
        }
        nextToken
      }
      pendingVideos {
        items {
          id
          owner
          title
          description
          status
          createdAt
          src_video
          category {
            id
            owner
            name
            description
            createdAt
          }
          pendingVideoCategoryId
          show {
            id
            owner
            title
            description
            release_date
          }
          pendingVideoShowId
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          pendingVideoDesignerId
          season
          episode
          duration
        }
        nextToken
      }
      pro
      subs {
        items {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          subDesignerId
          stripeId
          stripeSubId
          createdAt
          owner
        }
        nextToken
      }
      profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      draft_profile {
        first_name
        last_name
        name
        bio
        company_name
        title
        address_line1
        address_line2
        city
        state
        zip_code
        country
        website_url
        allow_contact_email
        facebook_handle
        twitter_handle
        youtube_handle
        pinterest_handle
        instagram_handle
        linkedin_url
        blog_url
        google_plus_url
        houzz_url
        feature_video
        availables
        certifications
        photo_url
        cover_url
        status
      }
      user {
        id
        owner
        email
        phone
        first_name
        last_name
        photo_url
        cover_url
        notes
        active
        createdAt
        watchlist {
          watchlistVideoId
          createdAt
        }
        currentVideo {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        history {
          historyVideoId
          createdAt
        }
        favorites {
          favoriteVideoId
          createdAt
        }
        designer {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
        userDesignerId
        subs {
          items {
            id
            subDesignerId
            stripeId
            stripeSubId
            createdAt
            owner
          }
          nextToken
        }
        orders {
          items {
            id
            owner
            orderCustomerId
            total
            order
            createdAt
          }
          nextToken
        }
        cart {
          id
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          owner
          items
        }
      }
      projects {
        items {
          id
          title
          description
          images
          videos
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          projectDesignerId
          owner
        }
        nextToken
      }
    }
  }
}
`;
export const createPost = `mutation CreatePost($input: CreatePostInput!) {
  createPost(input: $input) {
    id
    owner
    title
    description
    content
    status
    thumbnail
    editors {
      items {
        id
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        editor {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
      }
      nextToken
    }
    comments {
      items {
        id
        owner
        content
        avatar
        name
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        commentPostId
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        commentVideoId
        createdAt
        likes
        subs
      }
      nextToken
    }
    createdAt
    likes
    liked
  }
}
`;
export const updatePost = `mutation UpdatePost($input: UpdatePostInput!) {
  updatePost(input: $input) {
    id
    owner
    title
    description
    content
    status
    thumbnail
    editors {
      items {
        id
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        editor {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
      }
      nextToken
    }
    comments {
      items {
        id
        owner
        content
        avatar
        name
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        commentPostId
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        commentVideoId
        createdAt
        likes
        subs
      }
      nextToken
    }
    createdAt
    likes
    liked
  }
}
`;
export const deletePost = `mutation DeletePost($input: DeletePostInput!) {
  deletePost(input: $input) {
    id
    owner
    title
    description
    content
    status
    thumbnail
    editors {
      items {
        id
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        editor {
          id
          owner
          email
          phone
          name
          photo_url
          bio
          location
          active
          createdAt
          posts {
            nextToken
          }
          videos {
            nextToken
          }
          tags {
            nextToken
          }
          pendingVideos {
            nextToken
          }
          pro
          subs {
            nextToken
          }
          profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          draft_profile {
            first_name
            last_name
            name
            bio
            company_name
            title
            address_line1
            address_line2
            city
            state
            zip_code
            country
            website_url
            allow_contact_email
            facebook_handle
            twitter_handle
            youtube_handle
            pinterest_handle
            instagram_handle
            linkedin_url
            blog_url
            google_plus_url
            houzz_url
            feature_video
            availables
            certifications
            photo_url
            cover_url
            status
          }
          user {
            id
            owner
            email
            phone
            first_name
            last_name
            photo_url
            cover_url
            notes
            active
            createdAt
            userDesignerId
          }
          projects {
            nextToken
          }
        }
      }
      nextToken
    }
    comments {
      items {
        id
        owner
        content
        avatar
        name
        post {
          id
          owner
          title
          description
          content
          status
          thumbnail
          editors {
            nextToken
          }
          comments {
            nextToken
          }
          createdAt
          likes
          liked
        }
        commentPostId
        video {
          id
          owner
          title
          description
          status
          url
          thumbnail
          createdAt
          views {
            user
            video
            createdAt
          }
          comments {
            nextToken
          }
          products {
            nextToken
          }
          category {
            id
            owner
            name
            description
            createdAt
          }
          designers {
            nextToken
          }
          show {
            id
            owner
            title
            description
            release_date
          }
          season
          episode
          release_date
          duration
          likes
          src_video
          tags {
            nextToken
          }
        }
        commentVideoId
        createdAt
        likes
        subs
      }
      nextToken
    }
    createdAt
    likes
    liked
  }
}
`;
export const createComment = `mutation CreateComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    id
    owner
    content
    avatar
    name
    post {
      id
      owner
      title
      description
      content
      status
      thumbnail
      editors {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      createdAt
      likes
      liked
    }
    commentPostId
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    commentVideoId
    createdAt
    likes
    subs
  }
}
`;
export const updateComment = `mutation UpdateComment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    id
    owner
    content
    avatar
    name
    post {
      id
      owner
      title
      description
      content
      status
      thumbnail
      editors {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      createdAt
      likes
      liked
    }
    commentPostId
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    commentVideoId
    createdAt
    likes
    subs
  }
}
`;
export const deleteComment = `mutation DeleteComment($input: DeleteCommentInput!) {
  deleteComment(input: $input) {
    id
    owner
    content
    avatar
    name
    post {
      id
      owner
      title
      description
      content
      status
      thumbnail
      editors {
        items {
          id
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          editor {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
        }
        nextToken
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      createdAt
      likes
      liked
    }
    commentPostId
    video {
      id
      owner
      title
      description
      status
      url
      thumbnail
      createdAt
      views {
        user
        video
        createdAt
      }
      comments {
        items {
          id
          owner
          content
          avatar
          name
          post {
            id
            owner
            title
            description
            content
            status
            thumbnail
            createdAt
            likes
            liked
          }
          commentPostId
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          commentVideoId
          createdAt
          likes
          subs
        }
        nextToken
      }
      products {
        items {
          id
          owner
          product {
            id
            upc
            owner
            name
            description
            caption
            collection
            attributes
            price
            image
            product_id
            meta
            active
            createdAt
            box_size
            designer
            productCategoryId
            mainProductCategoryId
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          timestamp
        }
        nextToken
      }
      category {
        id
        owner
        name
        description
        createdAt
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      designers {
        items {
          id
          owner
          designer {
            id
            owner
            email
            phone
            name
            photo_url
            bio
            location
            active
            createdAt
            pro
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
      show {
        id
        owner
        title
        description
        release_date
        videos {
          items {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
          nextToken
        }
        pendingVideos {
          items {
            id
            owner
            title
            description
            status
            createdAt
            src_video
            pendingVideoCategoryId
            pendingVideoShowId
            pendingVideoDesignerId
            season
            episode
            duration
          }
          nextToken
        }
      }
      season
      episode
      release_date
      duration
      likes
      src_video
      tags {
        items {
          id
          tag {
            id
            tag
            type
            owner
          }
          video {
            id
            owner
            title
            description
            status
            url
            thumbnail
            createdAt
            season
            episode
            release_date
            duration
            likes
            src_video
          }
        }
        nextToken
      }
    }
    commentVideoId
    createdAt
    likes
    subs
  }
}
`;
export const createLike = `mutation CreateLike($input: CreateLikeInput!) {
  createLike(input: $input) {
    id
    subject
    objectId
    createdBy
    createdAt
    liked
    owner
  }
}
`;
export const updateLike = `mutation UpdateLike($input: UpdateLikeInput!) {
  updateLike(input: $input) {
    id
    subject
    objectId
    createdBy
    createdAt
    liked
    owner
  }
}
`;
export const deleteLike = `mutation DeleteLike($input: DeleteLikeInput!) {
  deleteLike(input: $input) {
    id
    subject
    objectId
    createdBy
    createdAt
    liked
    owner
  }
}
`;
